import { AsyncPipe, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Observable } from 'rxjs';

import { AcknowledgementService } from 'src/app/core/services/acknowledgement/acknowledgement.service';
import { LazyComponentId } from 'src/app/core/services/lazy-components/lazy-components-registry';

import { LazyHostComponent } from '../../core/lazy-host/lazy-host.component';

@Component({
  selector: 'cc-acknowledgement-container',
  templateUrl: './acknowledgement-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [LazyHostComponent, AsyncPipe, NgIf]
})
export class AcknowledgementContainerComponent {
  public componentId = LazyComponentId.Acknowledgement;
  public isModalOpen$: Observable<boolean> = this.acknowledgementService.listenToModalStateChanges();

  public constructor(private readonly acknowledgementService: AcknowledgementService) {}
}
